import { Box, Text, FillPreview, ColorPicker, FillButton } from '@wix/design-system';
import React__default, { useState, useContext } from 'react';
import { RicosContext, ZIndexContext } from 'ricos-context';
import { s as styleInject } from '../style-inject.es-e7b07dd7.js';
import { SWATCH_TOGGLE, SWATCHES, EMPTY_SWATCH, SWATCH } from './data-hooks.js';

var css_248z = "._64Jyo{display:grid;gap:12px;grid-template-columns:repeat(auto-fill,24px);justify-content:space-between}";
var classes = {"container":"_64Jyo"};
styleInject(css_248z);

const ToggledColorPicker = ({
  label,
  color,
  userColors,
  onChange,
  onNewColorAdded,
  onToggle,
  isExpanded,
  dataHook,
  showColorPicker,
  colorPickerClassName
}) => {
  return /* @__PURE__ */ React__default.createElement("div", { "data-hook": dataHook }, /* @__PURE__ */ React__default.createElement(Box, { align: "space-between", verticalAlign: "middle", marginTop: "SP1", marginBottom: "SP1" }, /* @__PURE__ */ React__default.createElement(Text, { size: "small" }, label), /* @__PURE__ */ React__default.createElement(Box, { width: "24px" }, /* @__PURE__ */ React__default.createElement(
    FillPreview,
    {
      content: void 0,
      fill: color,
      onClick: onToggle,
      dataHook: SWATCH_TOGGLE
    }
  ))), isExpanded ? /* @__PURE__ */ React__default.createElement(
    CustomColorPicker,
    {
      userColors,
      color,
      onChange,
      onNewColorAdded,
      showColorPicker,
      colorPickerClassName
    }
  ) : null);
};
const CustomColorPicker = ({
  userColors,
  color,
  onChange,
  onNewColorAdded,
  showColorPicker: initialShowColorPicker,
  colorPickerClassName
}) => {
  const [showColorPicker, setShowColorPicker] = useState(initialShowColorPicker);
  return /* @__PURE__ */ React__default.createElement(Box, { direction: "vertical", marginTop: "SP2", marginBottom: "SP2", gap: "SP2" }, /* @__PURE__ */ React__default.createElement(
    ColorSwatches,
    {
      userColors,
      selectedColor: color,
      onAddClick: () => setShowColorPicker(true),
      onChange
    }
  ), showColorPicker ? /* @__PURE__ */ React__default.createElement("div", { className: colorPickerClassName }, /* @__PURE__ */ React__default.createElement(
    ColorPicker,
    {
      value: color,
      showConverter: false,
      onChange: () => {
      },
      onConfirm: (color2) => {
        setShowColorPicker(false);
        const colorHex = typeof color2 === "string" ? color2 : color2.hex();
        if (!userColors.includes(colorHex)) {
          onNewColorAdded(colorHex);
        }
      },
      onCancel: () => setShowColorPicker(false)
    }
  )) : null);
};
const ColorSwatches = ({ userColors, onAddClick, onChange, selectedColor }) => {
  const { t } = useContext(RicosContext);
  const zIndexService = useContext(ZIndexContext);
  return /* @__PURE__ */ React__default.createElement("div", { className: classes.container, "data-hook": SWATCHES }, /* @__PURE__ */ React__default.createElement(
    FillButton,
    {
      iconSize: "small",
      onClick: onAddClick,
      dataHook: EMPTY_SWATCH,
      tooltipContent: t("ColorPickerAddCustomColor_Tooltip"),
      tooltipProps: {
        appendTo: (el) => {
          var _a;
          return Boolean((_a = el.getAttribute("data-hook")) == null ? void 0 : _a.includes("ricos-portal"));
        },
        zIndex: zIndexService.getZIndex("TOOLTIP")
      }
    }
  ), userColors.map((userColor) => /* @__PURE__ */ React__default.createElement(
    ColorSwatch,
    {
      key: userColor,
      fill: userColor,
      selectedColor,
      onClick: onChange
    }
  )));
};
const ColorSwatch = ({ fill, selectedColor, onClick }) => /* @__PURE__ */ React__default.createElement(Box, { width: "24px" }, /* @__PURE__ */ React__default.createElement(
  FillPreview,
  {
    selected: selectedColor === fill,
    onClick: () => onClick(fill),
    fill,
    dataHook: SWATCH
  }
));

export { ToggledColorPicker };
//# sourceMappingURL=toggled-color-picker.js.map
